import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["cb"];
import _capitalize from 'hs-lodash/capitalize';
import { ACTIONS, SCREENS } from '../../constants/Tracking';
import { associationTypesToCall, objectTypes, pluralTypeToSingle, toObjectTypes } from '../../constants/types';
import captureException from '../../utils/captureException';
import { associationSectionPromise } from '../../utils/helpers';
import { SET_ASSOCIATIONS, SET_ASSOCIATIONS_LOADING } from './reducer';
export const getAssociationSectionList = ({
  dispatch,
  apiWrapper
}, {
  callObjectId,
  featureAvailable
}) => {
  if (featureAvailable) {
    dispatch({
      type: SET_ASSOCIATIONS_LOADING,
      payload: true
    });
    associationSectionPromise({
      callObjectId,
      toObjectType: toObjectTypes.contact,
      fetchFunction: apiWrapper.fetchAssociationSectionList
    }).then(response => {
      dispatch({
        type: SET_ASSOCIATIONS,
        payload: response.results
      });
    }).catch(captureException).finally(() => {
      dispatch({
        type: SET_ASSOCIATIONS_LOADING,
        payload: false
      });
    });
  }
};
export const associateObject = ({
  apiWrapper,
  usageTracker
}, {
  objectId,
  cb,
  callObjectId
}) => {
  const associationType = associationTypesToCall[objectTypes.contacts];
  return apiWrapper.associateObject({
    objectType: objectTypes.contacts,
    associationType,
    objectId,
    toObjectId: callObjectId
  }).then(() => {
    usageTracker.trackUsage(Object.assign({
      screen: SCREENS[`associate${_capitalize(toObjectTypes.contact)}`],
      type: toObjectTypes.contact
    }, ACTIONS.associations.associated));
  }).catch(captureException).finally(() => {
    if (typeof cb === 'function') cb();
  });
};
export const disassociateObject = ({
  apiWrapper,
  usageTracker
}, _ref) => {
  let {
      cb
    } = _ref,
    data = _objectWithoutPropertiesLoose(_ref, _excluded);
  apiWrapper.removeAssociationObject(Object.assign({}, data, {
    objectId: +data.objectId,
    toObjectId: +data.toObjectId
  })).then(() => {
    usageTracker.trackUsage(Object.assign({
      screen: SCREENS[`associate${_capitalize(pluralTypeToSingle[data.objectType])}`],
      type: pluralTypeToSingle[data.objectType]
    }, ACTIONS.associations.dissociated));
    return data;
  }).catch(captureException).finally(() => {
    if (typeof cb === 'function') cb();
  });
};